import {util} from '@/utils/utils'
import {sessionUtil} from '@/utils/session.js'
import {validUtil} from '@/utils/valid.js'
import {deleteData} from './form-render';


export const getFileLookUrl = (id, ifThumb) => {
  let url = util.getBaseUrl() + '/api_v1/files/' + id + '/look?access_token=' + sessionUtil.getAccessToken()
  if(ifThumb !== undefined){
    url = url + '&ifThumb=' + ifThumb
  }
  return url
}

export const getFileDownloadUrl = (id, ifThumb) => {
  let url = util.getBaseUrl() + '/api_v1/files/' + id + '/download?access_token=' + sessionUtil.getAccessToken()
  if(ifThumb !== undefined){
    url = url + '&ifThumb=' + ifThumb
  }
  return url
}

export const getTempLookUrl = (id, ifThumb,fileName) => {
  let url = util.getBaseUrl() + '/api_v1/files/temp/' + id + '/look?access_token=' + sessionUtil.getAccessToken()
  if(ifThumb !== undefined){
    url = url + '&ifThumb=' + ifThumb
  }
  if(validUtil.isNotNull(fileName)){
    url = url + '&fileName=' + encodeURIComponent(fileName)
  }
  return url
}

export const getTempShareLookUrl = (id, ifThumb,fileName) => {
  let url = util.getBaseUrl() + '/share/temp/' + id + '/look?'
  if(ifThumb !== undefined){
    url = url + '&ifThumb=' + ifThumb
  }
  if(validUtil.isNotNull(fileName)){
    url = url + '&fileName=' + encodeURIComponent(fileName)
  }
  return url
}

export const getTempShareLookSimpleUrl = (id, ifThumb,fileName) => {
  let url = '/share/temp/' + id + '/look?'
  if(ifThumb !== undefined){
    url = url + '&ifThumb=' + ifThumb
  }
  if(validUtil.isNotNull(fileName)){
    url = url + '&fileName=' + encodeURIComponent(fileName)
  }
  return url
}

export const getFileShareLookUrl = (id, ifThumb,fileName) => {
  let url = util.getBaseUrl() + '/share/' + id + '/look?'
  if(ifThumb !== undefined){
    url = url + '&ifThumb=' + ifThumb
  }
  if(validUtil.isNotNull(fileName)){
    url = url + '&fileName=' + encodeURIComponent(fileName)
  }
  return url
}

export const getTempDownUrl = (id, ifThumb,fileName) => {
  let url = util.getBaseUrl() + '/api_v1/files/temp/' + id + '/download?access_token=' + sessionUtil.getAccessToken()
  if(ifThumb !== undefined){
    url = url + '&ifThumb=' + ifThumb
  }
  if(validUtil.isNotNull(fileName)){
    url = url + '&fileName=' + encodeURIComponent(fileName)
  }
  return url
}

export const deleteFile = (id) => {
  var p = new Promise(function (resolve, reject) {
    util.confirm('确认删除吗？',()=>{
      deleteData({'tableName':'t_attachment','businessKey':id}).then(()=>{
        resolve()
      })
    })
  })
  return p
}



// WEBPACK FOOTER //
// ./src/api/attachment.js